import { Component, Input, ViewChild, ViewChildren, Renderer2, AfterViewChecked, inject } from '@angular/core';
import { QuestionnaireFilePreviewComponent } from '../questionnaire-file-preview/questionnaire-file-preview.component';

import { Questionnaire } from '@models/questionnaire';
import { AuthUserService } from '../../../services/auth-user.service';

import { canPreview, isPdf } from '@functions/file-types';
import { getFileExtension } from '@functions/check-string';

@Component({
  selector: 'app-questionnaire-detail-student',
  templateUrl: './questionnaire-detail-student.component.html',
  styleUrls: ['./questionnaire-detail-student.component.scss'],
  standalone: false,
})
export class QuestionnaireDetailStudentComponent implements AfterViewChecked {
  authUserService = inject(AuthUserService);
  private renderer = inject(Renderer2);

  @Input() questionnaire: Questionnaire;
  @Input() categoryName: string;

  @ViewChildren('upload_div') upload_divs;
  @ViewChild(QuestionnaireFilePreviewComponent, { static: true }) filePreview: QuestionnaireFilePreviewComponent;

  ngAfterViewChecked() {
    this.resize();
  }

  getListAnswer(answer: any) {
    if (!answer) {
      return [];
    }
    return Array.isArray(answer) ? answer : [answer];
  }

  getListAnswerOption(answer: any) {
    if (answer.answer_options) {
      return answer.answer_options || [];
    } else if (answer.text || answer.src) {
      return [{ text: answer.text, src: answer.src }];
    }
    return [];
  }

  isShowThumbnail(file: string) {
    const PreviewType = ['jpg', 'jpeg', 'gif', 'png'];
    const fileExtension = getFileExtension(file);
    return PreviewType.includes(fileExtension);
  }

  resize() {
    if (!this.upload_divs) {
      return;
    }
    this.upload_divs.forEach((upload_div) => {
      const imageDiv = upload_div.nativeElement.querySelectorAll('.attach-file');
      for (const div of imageDiv) {
        this.renderer.setStyle(div, 'height', getComputedStyle(div).width);
      }
    });
  }

  onFileClick(answer) {
    if (canPreview(getFileExtension(answer.attached_file_name))) {
      this.filePreview.onPreview(answer.attached, answer.attached_file_name);
    } else {
      window.open(answer.attached + '/download');
    }
  }

  showDownloadIcon(answer) {
    const fileExtension = getFileExtension(answer.attached_file_name);
    return !canPreview(fileExtension) && !isPdf(fileExtension);
  }

  isTeacher() {
    return !!this.questionnaire.commented_user && this.questionnaire.commented_user.userTypeId === 1;
  }
}
